/**
 * DeepSeek: Models for text generation
 */
export enum AxAIDeepSeekModel {
  DeepSeekChat = 'deepseek-chat',
  DeepSeekCoder = 'deepseek-coder',
  DeepSeekReasoner = 'deepseek-reasoner',
}
